'use strict'

export default class Loading {
    constructor() {
        const listener = () => {
            setTimeout(() => {
                Loading.fade();
            },500);
            window.staticEvents.removeListener('loaded',listener);
        };
        window.staticEvents.addListener('loaded',listener);
    }
    static fade() {
        $('#loading').css('transition', 'all 1s');
        $('#loading svg').css('transition', 'all 0.25s');
        $('#loading svg').css('opacity', '0');
        $('#loading').css('opacity', '0');
        setTimeout(() => {
            $('#loading').remove();
        },1000);
    }
}
